import { useContext } from "react";

import { CheckoutContext } from "contexts/CheckoutProvider";

import {
  MembershipState,
  MembershipStep,
} from "components/Membership/membershipTypes";
import StepFall25Promo from "components/Step/StepFall25Promo";

export const MembershipStepFall25Promo = ({
  routePrevStep,
  routeNextStep,
}: MembershipState) => {
  const { addPromoCode } = useContext(CheckoutContext);

  const onBackButtonClick = () => {
    routePrevStep?.();
  };

  const onNextButtonClick = async () => {
    await addPromoCode?.("495fall25");
    routeNextStep?.();
  };

  return (
    <StepFall25Promo
      onBackButtonClick={onBackButtonClick}
      onNextButtonClick={onNextButtonClick}
    />
  );
};

export const MEMBERSHIP_STEP_FALL25_PROMO: MembershipStep = {
  component: MembershipStepFall25Promo,
  id: "membership-id-fall25-promo",
  slug: "fall25-promo",
};

export default MembershipStepFall25Promo;
